import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const Container = styled.div`
    position: absolute;
    top: ${({top}) => (top ? '5%' : '')};
    left: ${({left}) => (left ? '50%' : '')};
    transform: ${({left}) => (left ? 'translateX(-50%)' : '')};
    bottom: ${({bottom,footer}) => (bottom ? '0.3%' : (footer && '100%'))};
    right: ${({right}) => (right ? '5%' : '')};
    display: flex;
    justify-content: center;
    align-items: center;
    background: inherit;
    // flex-wrap: wrap;

    @media (max-width: 1350px) {
        top: ${({top}) => (top ? '13%' : '')};
    }
    @media (max-width: 850px) {
        top: ${({top}) => (top ? '15%' : '')};
    }
    @media (max-width: 700px) {
        width: 90vw;
        flex-wrap: wrap;
    }
    
    // @media (max-width: 850px) {
    //     display: ${({top}) => (top && "none" )};
    // }

    
      &::before {
        content: "";
        position: absolute;
        width: 120%;
        height: 100%;
        background-color: rgba(255,255,255,0.2);
        border-radius: 3px;
        z-index: -999;

        @media (max-width: 860px) {
            width: 110%;
        }
        @media (max-width: 750px) {
            width: 100%;
        }
      }
`;

export const Item = styled.a`
    color: #ffffff;
    padding: 1rem 1.2rem;
    text-decoration: none;
    transition: transform .1s ease-out;

    @media (max-width: 860px) {
        padding: 1rem 1rem;
    };

    @media (max-width: 750px) {
        padding: 1rem 0.8rem;
    };
    
    &:hover{
        color: #eec653;
        transform: scale(1.05);
    }
    &:active {
        transform: scale(1);
    }
`;